import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["daysSection", "frequency", "enabledCheckbox"]

  connect() {
    this.updateVisibility()
  }

  enabledValueChanged(event) {
    this.updateVisibility()
  }

  updateFrequency() {
    this.updateVisibility()
  }

  updateVisibility() {
    const enabledCheckbox = this.element.querySelector('input[name="user[digest_enabled]"][type="checkbox"]')
    const enabled = enabledCheckbox ? enabledCheckbox.checked : false
    const frequency = this.hasFrequencyTarget ? this.frequencyTarget.value : "never"
    const shouldShowDays = enabled && frequency !== "never"

    // Find the preferences section (the .space-y-4 div that contains the form fields)
    const preferencesSection = this.element.querySelector('.space-y-4:last-child')
    
    if (preferencesSection) {
      if (enabled) {
        preferencesSection.style.opacity = "1"
        preferencesSection.querySelectorAll('input, select').forEach(el => {
          el.disabled = false
        })
      } else {
        preferencesSection.style.opacity = "0.5"
        preferencesSection.querySelectorAll('input, select').forEach(el => {
          el.disabled = true
        })
      }
    }

    // Show/hide days section based on frequency
    if (this.hasDaysSectionTarget) {
      if (shouldShowDays) {
        this.daysSectionTarget.style.display = "block"
        this.daysSectionTarget.style.opacity = "1"
      } else {
        this.daysSectionTarget.style.display = "none"
      }
    }
  }
} 